import AutoDetect from '@/components/AutoDetect';
import RequiredValidPostCode from '@/components/RequiredValidPostCode';
import React from 'react';

const GeolocationAndValidity = () => {
  return (
    <div>
      <AutoDetect />
      <RequiredValidPostCode />
    </div>
  );
};

export default GeolocationAndValidity;
